import React from 'react';

const formatLabel = value => value.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
const flattenSnapshot = (value, path = '', result = {}) => {
  if (value && typeof value === 'object' && Object.keys(value).length) {
    Object.entries(value).forEach(([key, child]) => {
      if (['display_data', 'request_revision'].includes(key)) return;
      flattenSnapshot(child, [path, Array.isArray(value) ? Number(key) + 1 : formatLabel(key)].filter(Boolean).join(' · '), result);
    });
  } else if (path) {
    result[path] = value == null || value === '' ? '—' : typeof value === 'boolean' ? value ? 'Yes' : 'No' : typeof value === 'object' ? '—' : String(value);
  }
  return result;
};

const AuditRows = ({ fields, before, after, hasBefore }) => (
  <dl className="ticket-audit-rows">
    {fields.map(field => <div className="ticket-audit-row" key={field}>
      <dt>{field}</dt>
      <dd>
        {hasBefore && <span className="ticket-audit-before">Before: {before[field] ?? '—'}</span>}
        <span className="ticket-audit-after">{hasBefore ? 'After: ' : ''}{after[field] ?? '—'}</span>
      </dd>
    </div>)}
  </dl>
);

const TicketRequestAudit = ({ entry }) => {
  const before = flattenSnapshot(entry.from || {});
  const after = flattenSnapshot(entry.to || {});
  const fields = [...new Set([...Object.keys(before), ...Object.keys(after)])];
  const changes = fields.filter(field => before[field] !== after[field]);
  const hasBefore = !!entry.from;
  return (
    <div className="ticket-request-audit">
      {hasBefore && <p className="ticket-muted">{changes.length} {changes.length === 1 ? 'change' : 'changes'}
        {entry.to?.request_revision != null && ` · Revision ${entry.to.request_revision}`}</p>}
      <AuditRows fields={hasBefore ? changes : fields} before={before} after={after} hasBefore={hasBefore} />
      {hasBefore && <details style={{ marginTop: '0.75rem' }}>
        <summary style={{ cursor: 'pointer', color: 'var(--text-secondary)' }}>View complete saved version</summary>
        <AuditRows fields={fields} before={before} after={after} hasBefore />
      </details>}
    </div>
  );
};

export default TicketRequestAudit;
